export const ENV = {
    BASE_URL: '/',
    API_MODE: 'api',//json
    API_URL: 'https://api.prod.itakusaki-manager.deloitte.jp/api/admin',
     	APP_API_URL: 'https://api.prod.itakusaki-manager.deloitte.jp/api/',
	APP_URL_BANNER: 'https://api.prod.itakusaki-manager.deloitte.jp/storage/',
        APP_URL_DOMAIN: 'https://user.prod.itakusaki-manager.deloitte.jp/',
        DOWNLOAD_URL: 'https://api.prod.itakusaki-manager.deloitte.jp/download?url='
}

export default ENV;
